import React from 'react'
const CardMode = ({ fillColor = '#FFFFFF' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none">
        <path d="M7.6 0.4L0.4 0.4 0.4 7.6 7.6 7.6 7.6 0.4ZM6.4 1.6L6.4 6.4 1.6 6.4 1.6 1.6 6.4 1.6Z" />
        <path d="M7.6 8.4L0.4 8.4 0.4 15.6 7.6 15.6 7.6 8.4ZM6.4 9.6L6.4 14.4 1.6 14.4 1.6 9.6 6.4 9.6Z" />
        <path d="M15.6 0.4L8.4 0.4 8.4 7.6 15.6 7.6 15.6 0.4ZM14.4 1.6L14.4 6.4 9.6 6.4 9.6 1.6 14.4 1.6Z" />
        <path d="M15.6 8.4L8.4 8.4 8.4 15.6 15.6 15.6 15.6 8.4ZM14.4 9.6L14.4 14.4 9.6 14.4 9.6 9.6 14.4 9.6Z" />
      </g>
  </svg>
)
export default CardMode
